export default class PublicationCard {
  constructor(options) {
    this.$el = options.$el;

    this.button = this.$el.querySelector(".btnSecondary");
    this.setEvents();
  }

  setEvents() {
    this.$el.addEventListener("mouseenter", () => {
      this.button.classList.toggle("active");
    });

    this.$el.addEventListener("mouseleave", () => {
      this.button.classList.toggle("active");
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/PublicationCard.js